import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from '../../../base/dialog/actions';
import DetailPollDialog from './DetailPollDialog';
import { TYPE } from './constant';
import { useTranslation } from 'react-i18next';
import { COMMAND_REOPEN_POLL } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        listItem: {
            display: 'flex',
            flexDirection: 'column',
            padding: '8px 0'
        },
        item: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'Sarabun',
            cursor: 'pointer',
            padding: '8px 20px',
            '&:hover': {
                color: theme.palette.textHover,
                backgroundColor: theme.palette.backgroundTextHover
            },
            '&:nth-last-child': {
                marginBottom: '0px !important'
            }
        }
    };
});
const DotContent = React.forwardRef(({ poll, pollId, changeVote, answers, handleClose, skipAnswer, skipChangeVote, checkEmpty, handleEndPoll, handleDetelePoll, removeMyAnswer }, ref) => {
    const { classes, theme } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { conference } = useSelector((state) => state['features/base/conference']);
    const reOpenPoll = (pollId) => {
        conference?.sendPollMessage({
            type: COMMAND_REOPEN_POLL,
            poll_id: pollId
        });
    };
    return (React.createElement("div", { className: classes.listItem },
        poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id &&
            React.createElement("div", { className: classes.item, onClick: () => {
                    handleDetelePoll();
                } }, t("polls.dotContent.deleteVote")),
        poll.status === TYPE.STARTED && poll?.lastVote?.find((el) => el) &&
            React.createElement("div", { className: classes.item, onClick: () => {
                    removeMyAnswer();
                    handleClose();
                } }, t("polls.dotContent.deleteMyAnswer")),
        (poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id || (poll.status === TYPE.STARTED && poll?.lastVote?.find((el) => el))) &&
            React.createElement("span", { style: { width: '100%', height: '1px', backgroundColor: '#E9E9E9', margin: '8px 0' } }),
        poll.status === TYPE.ENDED &&
            poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id &&
            React.createElement("div", { className: classes.item, onClick: () => {
                    reOpenPoll(poll?.pollId);
                    handleClose();
                } }, t("polls.dotContent.reOpen")),
        poll.status !== TYPE.ENDED &&
            poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id &&
            React.createElement("div", { className: classes.item, onClick: () => handleEndPoll(poll?.pollId) }, t("polls.dotContent.endVote")),
        ((poll.status === TYPE.ENDED && poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id)
            ||
                (poll.status !== TYPE.ENDED && poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id)) &&
            React.createElement("span", { style: { width: '100%', height: '1px', backgroundColor: '#E9E9E9', margin: '8px 0' } }),
        React.createElement("div", { className: classes.item, onClick: () => {
                dispatch(openDialog(DetailPollDialog, {
                    answers: answers,
                    poll: poll
                }));
                handleClose();
            } }, t("polls.dotContent.viewResult"))));
});
export default DotContent;
